import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaginationDots',
    props: {
        totalItems: {},
        currentIndex: {},
        maxDots: { default: 5 }
    },
    setup(__props) {
        const props = __props;
        const visibleDots = computed(() => {
            const totalDots = props.totalItems;
            const halfWindow = Math.floor(props.maxDots / 2);
            if (totalDots <= props.maxDots) {
                return Array.from({ length: totalDots }, (_, i) => ({ index: i, smaller: false }));
            }
            let start = Math.max(0, props.currentIndex - halfWindow);
            let end = start + props.maxDots;
            // Adjust the window if it exceeds the total dots
            if (end > totalDots) {
                end = totalDots;
                start = totalDots - props.maxDots;
            }
            return Array.from({ length: end - start }, (_, i) => {
                const index = start + i;
                return {
                    index,
                    smaller: (index === start && start > 0) || (index === end - 1 && end < totalDots)
                };
            });
        });
        return (_ctx, _cache) => {
            return (_ctx.totalItems > 1)
                ? (_openBlock(), _createBlock(_TransitionGroup, {
                    key: 0,
                    tag: "div",
                    name: "dot-slide",
                    class: "pagination-dots"
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleDots.value, (dot) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: dot.index,
                                class: _normalizeClass(['dot', { active: dot.index === _ctx.currentIndex, smaller: dot.smaller }])
                            }, null, 2));
                        }), 128))
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
